// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating Chat Bot Styles */

.floating-chat-button {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
  }
  50% {
    box-shadow: 0 4px 25px rgba(59, 130, 246, 0.5);
  }
  100% {
    box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
  }
}

.floating-chat-modal {
  animation: slideUpFadeIn 0.3s ease-out;
}

@keyframes slideUpFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Chat Messages Scrollbar */
.floating-chat-modal .MuiBox-root:nth-of-type(2)::-webkit-scrollbar {
  width: 4px;
}

.floating-chat-modal .MuiBox-root:nth-of-type(2)::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.floating-chat-modal .MuiBox-root:nth-of-type(2)::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.floating-chat-modal .MuiBox-root:nth-of-type(2)::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Table Responsive Styles */
.floating-chat-modal .ant-table {
  font-size: 11px;
}

.floating-chat-modal .ant-table-thead > tr > th {
  padding: 8px 4px;
  font-size: 10px;
  font-weight: 600;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.floating-chat-modal .ant-table-tbody > tr > td {
  padding: 6px 4px;
  font-size: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.floating-chat-modal .ant-table-tbody > tr:hover > td {
  background: #f8f9fa;
}

/* Plotly Chart Responsive */
.floating-chat-modal .js-plotly-plot {
  border-radius: 8px;
  overflow: hidden;
}

/* Message Animations */
.floating-chat-modal .MuiBox-root[sx*="alignSelf"] {
  animation: messageSlideIn 0.3s ease-out;
}

@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Loading Animation */
@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
}

.floating-chat-modal .MuiCircularProgress-root {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .floating-chat-modal {
    width: calc(100vw - 20px) !important;
    height: calc(100dvh - 96px) !important;
    max-height: calc(100vh - 96px) !important;
    bottom: max(16px, env(safe-area-inset-bottom)) !important;
    right: 10px !important;
    left: 10px !important;
  }

  .floating-chat-button {
    bottom: max(16px, env(safe-area-inset-bottom)) !important;
    right: max(16px, env(safe-area-inset-right)) !important;
    width: 50px !important;
    height: 50px !important;
  }

  .floating-chat-button svg {
    width: 24px !important;
    height: 24px !important;
  }
}

@media (min-width: 641px) and (max-width: 768px) {
  .floating-chat-modal {
    width: min(450px, calc(100vw - 24px)) !important;
    height: min(600px, calc(100dvh - 96px)) !important;
  }
}

@media (max-width: 480px) {
  .floating-chat-modal {
    width: 100vw !important;
    height: calc(100dvh - 64px) !important;
    max-height: calc(100vh - 64px) !important;
    bottom: 0 !important;
    right: 0 !important;
    left: 0 !important;
    border-radius: 16px 16px 0 0 !important;
  }
}

/* Custom Input Styles */
.floating-chat-modal .MuiTextField-root {
  animation: inputFocus 0.2s ease-out;
}

@keyframes inputFocus {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.02);
  }
}

.floating-chat-modal .MuiOutlinedInput-root.Mui-focused {
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

/* Message Content Styling */
.floating-chat-modal h1, 
.floating-chat-modal h2, 
.floating-chat-modal h3 {
  margin: 8px 0 4px 0;
  color: #2d3748;
  line-height: 1.3;
}

.floating-chat-modal h1 { font-size: 16px; }
.floating-chat-modal h2 { font-size: 14px; }
.floating-chat-modal h3 { font-size: 13px; }

.floating-chat-modal p {
  margin: 4px 0;
  line-height: 1.5;
}

.floating-chat-modal ul, 
.floating-chat-modal ol {
  margin: 8px 0;
  padding-left: 16px;
}

.floating-chat-modal li {
  margin: 2px 0;
  line-height: 1.4;
}

.floating-chat-modal code {
  background: #f7fafc;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 12px;
  color: #4a5568;
}

.floating-chat-modal pre {
  background: #f7fafc;
  padding: 8px;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 11px;
  margin: 8px 0;
}

/* Notification Badge */
.floating-chat-button .notification-badge {
  animation: bounce 0.5s ease-in-out;
}

@keyframes bounce {
  0%, 20%, 53%, 80%, 100% {
    transform: translate3d(0,0,0);
  }
  40%, 43% {
    transform: translate3d(0, -8px, 0);
  }
  70% {
    transform: translate3d(0, -4px, 0);
  }
  90% {
    transform: translate3d(0, -1px, 0);
  }
}

/* ===== Dark theme overrides (MUI surfaces handled by provider) ===== */
[data-theme="dark"] .floating-chat-modal h1,
[data-theme="dark"] .floating-chat-modal h2,
[data-theme="dark"] .floating-chat-modal h3 {
  color: var(--text);
}
[data-theme="dark"] .floating-chat-modal code,
[data-theme="dark"] .floating-chat-modal pre {
  background: var(--surface-3);
  color: var(--text);
}
[data-theme="dark"] .floating-chat-modal .ant-table-thead > tr > th {
  background: var(--surface-3);
  color: var(--text);
  border-bottom-color: var(--border);
}
[data-theme="dark"] .floating-chat-modal .ant-table-tbody > tr > td {
  border-bottom-color: var(--border);
}
[data-theme="dark"] .floating-chat-modal .ant-table-tbody > tr:hover > td {
  background: var(--surface-hover);
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatBot/FloatingChatBot.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,oCAAoC;IACpC,sCAAsC;IACtC,yCAAyC;IACzC,yDAAyD;IACzD,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,yDAAyD;IACzD,uDAAuD;IACvD,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sCAAsC;IACtC,yCAAyC;IACzC,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;EACzC;AACF;;AAEA,wBAAwB;AACxB;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;;;EAGE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;;AAE3C;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA,wEAAwE;AACxE;;;EAGE,kBAAkB;AACpB;AACA;;EAEE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC","sourcesContent":["/* Floating Chat Bot Styles */\n\n.floating-chat-button {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);\n  }\n  50% {\n    box-shadow: 0 4px 25px rgba(59, 130, 246, 0.5);\n  }\n  100% {\n    box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);\n  }\n}\n\n.floating-chat-modal {\n  animation: slideUpFadeIn 0.3s ease-out;\n}\n\n@keyframes slideUpFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Chat Messages Scrollbar */\n.floating-chat-modal .MuiBox-root:nth-of-type(2)::-webkit-scrollbar {\n  width: 4px;\n}\n\n.floating-chat-modal .MuiBox-root:nth-of-type(2)::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 2px;\n}\n\n.floating-chat-modal .MuiBox-root:nth-of-type(2)::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 2px;\n}\n\n.floating-chat-modal .MuiBox-root:nth-of-type(2)::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Table Responsive Styles */\n.floating-chat-modal .ant-table {\n  font-size: 11px;\n}\n\n.floating-chat-modal .ant-table-thead > tr > th {\n  padding: 8px 4px;\n  font-size: 10px;\n  font-weight: 600;\n  background: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.floating-chat-modal .ant-table-tbody > tr > td {\n  padding: 6px 4px;\n  font-size: 10px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.floating-chat-modal .ant-table-tbody > tr:hover > td {\n  background: #f8f9fa;\n}\n\n/* Plotly Chart Responsive */\n.floating-chat-modal .js-plotly-plot {\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n/* Message Animations */\n.floating-chat-modal .MuiBox-root[sx*=\"alignSelf\"] {\n  animation: messageSlideIn 0.3s ease-out;\n}\n\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Loading Animation */\n@keyframes typing {\n  0%, 60%, 100% {\n    transform: translateY(0);\n  }\n  30% {\n    transform: translateY(-10px);\n  }\n}\n\n.floating-chat-modal .MuiCircularProgress-root {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 640px) {\n  .floating-chat-modal {\n    width: calc(100vw - 20px) !important;\n    height: calc(100dvh - 96px) !important;\n    max-height: calc(100vh - 96px) !important;\n    bottom: max(16px, env(safe-area-inset-bottom)) !important;\n    right: 10px !important;\n    left: 10px !important;\n  }\n\n  .floating-chat-button {\n    bottom: max(16px, env(safe-area-inset-bottom)) !important;\n    right: max(16px, env(safe-area-inset-right)) !important;\n    width: 50px !important;\n    height: 50px !important;\n  }\n\n  .floating-chat-button svg {\n    width: 24px !important;\n    height: 24px !important;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 768px) {\n  .floating-chat-modal {\n    width: min(450px, calc(100vw - 24px)) !important;\n    height: min(600px, calc(100dvh - 96px)) !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .floating-chat-modal {\n    width: 100vw !important;\n    height: calc(100dvh - 64px) !important;\n    max-height: calc(100vh - 64px) !important;\n    bottom: 0 !important;\n    right: 0 !important;\n    left: 0 !important;\n    border-radius: 16px 16px 0 0 !important;\n  }\n}\n\n/* Custom Input Styles */\n.floating-chat-modal .MuiTextField-root {\n  animation: inputFocus 0.2s ease-out;\n}\n\n@keyframes inputFocus {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.02);\n  }\n}\n\n.floating-chat-modal .MuiOutlinedInput-root.Mui-focused {\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n/* Message Content Styling */\n.floating-chat-modal h1, \n.floating-chat-modal h2, \n.floating-chat-modal h3 {\n  margin: 8px 0 4px 0;\n  color: #2d3748;\n  line-height: 1.3;\n}\n\n.floating-chat-modal h1 { font-size: 16px; }\n.floating-chat-modal h2 { font-size: 14px; }\n.floating-chat-modal h3 { font-size: 13px; }\n\n.floating-chat-modal p {\n  margin: 4px 0;\n  line-height: 1.5;\n}\n\n.floating-chat-modal ul, \n.floating-chat-modal ol {\n  margin: 8px 0;\n  padding-left: 16px;\n}\n\n.floating-chat-modal li {\n  margin: 2px 0;\n  line-height: 1.4;\n}\n\n.floating-chat-modal code {\n  background: #f7fafc;\n  padding: 2px 4px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #4a5568;\n}\n\n.floating-chat-modal pre {\n  background: #f7fafc;\n  padding: 8px;\n  border-radius: 8px;\n  overflow-x: auto;\n  font-size: 11px;\n  margin: 8px 0;\n}\n\n/* Notification Badge */\n.floating-chat-button .notification-badge {\n  animation: bounce 0.5s ease-in-out;\n}\n\n@keyframes bounce {\n  0%, 20%, 53%, 80%, 100% {\n    transform: translate3d(0,0,0);\n  }\n  40%, 43% {\n    transform: translate3d(0, -8px, 0);\n  }\n  70% {\n    transform: translate3d(0, -4px, 0);\n  }\n  90% {\n    transform: translate3d(0, -1px, 0);\n  }\n}\n\n/* ===== Dark theme overrides (MUI surfaces handled by provider) ===== */\n[data-theme=\"dark\"] .floating-chat-modal h1,\n[data-theme=\"dark\"] .floating-chat-modal h2,\n[data-theme=\"dark\"] .floating-chat-modal h3 {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .floating-chat-modal code,\n[data-theme=\"dark\"] .floating-chat-modal pre {\n  background: var(--surface-3);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .floating-chat-modal .ant-table-thead > tr > th {\n  background: var(--surface-3);\n  color: var(--text);\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .floating-chat-modal .ant-table-tbody > tr > td {\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .floating-chat-modal .ant-table-tbody > tr:hover > td {\n  background: var(--surface-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
